import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, Campaigns, Campus, ConsentementMultiple, Disponibilites, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { useForms, useSalesforce, useSubmission, useUrlReturn } from "hooks"
import { APPOINTMENT, CALL_PHONE, campaigns, consent, consentement, defaultValues, salutations } from "services"
import { useState } from "react"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar, setSnackMessage, setSnackSeverity } = useForms()
  const { url } = useUrlReturn('SUPINFO-ATELIER')
  const { url: url_contact } = useUrlReturn('SUPINFO-CONTACT')
  const { submission } = useSubmission()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...campaigns,
      ...consent,
      lead: {
        ...defaultValues,
        ...consentement,
        PostalCode: '',
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, watch } = methods
  // State
  const [optionsAcademicLevels, setOptionsAcademicLevels] = useState([])
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const slotId = data.slotId
    const places = data.accompagnateurs || 0
    // Si on a choisi un créneau, on vérifie si le créneau est toujours dispo
    if (slotId !== '') {
      const slot = await salesforce.checkSlot(slotId, places)
      if (slot.length === 0) {
        setOpenSnackbar(true)
        setSnackMessage('Désolé les dernières places ont été prises. Veuillez choisir une autre date ou un autre créneau')
        setSnackSeverity('warning')
        return
      }
    }

    const defaultDataLead = {
      Division__c: 'SUPINFO',
      IONISSchool__c: 'SUPINFO',
      LastForm__c: campaignId !== 'unavailable' ? 'Atelier' : 'Demande de rendez-vous',
      LeadSource: campaignId !== 'unavailable' ? 'Atelier' : 'Demande de rendez-vous',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      // await salesforce.createLead(finalLead)
      if (campaignId !== 'unavailable') {
        await submission({
          formId: 'ATELIER',
          lead: finalLead,
          campaignId: campaignId,
          campaignStatus: data.status,
          slotId: slotId,
          places: places,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        document.location.href=`${url}?campus=${campus}&campaignId=${campaignId}`
      } else {
        let description = ''

        if (data.availabilities.type === 'Être rappelé(e) sur Skype') {
          description = 'ID Skype : ' + data.availabilities.skypeId + '\n\n'
        }
        description += data.availabilities.dates.join(', ')

        const subject = data.availabilities.type
        await submission({
          formId: 'CONTACT',
          lead: finalLead,
          subject: subject,
          description: description,
          utmCookieName: '_ionis_user_data' // optionnel
        })
        document.location.href=`${url_contact}?campus=${campus}`
      }
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const watchCampaignId = watch('campaignId')
  const campus = watch('lead.Campus__c')
  // useEffect
  useSalesforce('SupinfoLead')
  // Functions
  const handleAcademicLevels = (academics) => {
    setOptionsAcademicLevels(academics)
  }

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel academics={optionsAcademicLevels.map(level => level.value)} options={optionsAcademicLevels} school="SUPINFO" section={false} specialites={false} />
        <Grid item xs={12}>
          <InputText control={control} label="Code postal" name="lead.PostalCode" />
        </Grid>
        <Campus label="Campus souhaité" />
        <Campaigns limit={4} division="Supinfo" school="Supinfo" setAcademicLevels={handleAcademicLevels} text="à l'atelier" type="Atelier" />
        <Disponibilites availabilities={[{ label: CALL_PHONE, value: CALL_PHONE }, { label: APPOINTMENT , value: APPOINTMENT }]} text="les ateliers" />
        <ConsentementMultiple callOptIn={watchCampaignId === 'unavailable'} />
        <RequiredFields />
        <Submit onSubmit={onSubmit} />
      </Grid>
    </FormProvider>
  )
}

export default Form
